export const NUMBER_OF_GUESTS_ANCHOR_GAP = 10;
export const NUMBER_OF_GUESTS_PINNED_ANCHOR_GAP = 4;

export const PERFECT_DAY_AT_COCOCAY_GUESTS_COUNT = 2;
